import { render, staticRenderFns } from "./FormUbicacionEntrega.vue?vue&type=template&id=a4c450e0&"
import script from "./FormUbicacionEntrega.vue?vue&type=script&lang=js&"
export * from "./FormUbicacionEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports